import { render } from "./Transportation.vue?vue&type=template&id=348a53ec&scoped=true"
import script from "./Transportation.vue?vue&type=script&lang=js"
export * from "./Transportation.vue?vue&type=script&lang=js"

import "./Transportation.vue?vue&type=style&index=0&id=348a53ec&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348a53ec"]])

export default __exports__